<template>
  <Modal
    :modal-types="[START_INTERACTIVE_TOUR_MODAL]"
    :should-add-content-padding="false"
    :is-wide-modal="true"
  >
    <div class="interactive-tour-modal">
      <div class="interactive-tour-modal-header-image">
        <img
          src="//d.stockcharts.com/img/bg-modal-header-02.jpg"
          alt="StockCharts Tour"
        />
      </div>
      <div class="interactive-tour-modal-body">
        <h2 class="interactive-tour-heading">
          Welcome to the new SharpCharts Workbench! Let's take a quick look around
        </h2>
        <div class="interactive-tour-info">
          <div>
            There's a ton to explore here on the latest generation of our SharpCharts Workbench, but we're here to help.
            This brief tour will familiarize you with the most important features and make sure you know how to take full advantage of everything SharpCharts has to offer.
            So, let's dive in!
          </div>
        </div>
        <div>
          <button
            type="button"
            class="sc3-button sc3-button-green sc3-button-extra-large"
            @click="[startInteractiveTour(), closeModal()]"
          >
            Start&nbsp;The&nbsp;Tour
          </button>
          <br />
          <button
            type="button"
            class="sc3-button-link"
            @click="closeModal()"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts" setup>
  import Modal from '@/components/modals/Modal.vue';
  import { useModals } from '@/composables/useModals';
  import { useInteractiveTour } from '@/composables/useInteractiveTour';

  const { START_INTERACTIVE_TOUR_MODAL, closeModal } = useModals();
  const { startInteractiveTour } = useInteractiveTour();
</script>

<style scoped>
  .interactive-tour-modal {
    text-align: center;
  }

  .interactive-tour-modal-header-image {
    border-radius: 6px 6px 0px 0px;
  }

  .interactive-tour-modal-header-image img {
    max-width: 100%;
  }

  .interactive-tour-modal-body {
    padding: 10px;
  }

  .interactive-tour-heading {
    font-family: 'Roboto Condensed', 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 900;
    font-size: 25px;
  }

  .interactive-tour-info div {
    margin-bottom: 10px;
    color: #707f8f;
    font-size: 15px;
  }
</style>
